import React, { Component } from 'react'

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ergelt_is: false,
    }
  }
  render() {
    return (
      <div>
        <div className='mainDiv'>
          <div className={this.state.ergelt_is ? "boxDiv trans-90" : "boxDiv"}>
            <div className="masthead negtal front">
              <img src={require('../../static/img/mangaa_isometric.png')} className="utasnuud" alt=""></img>
              <div className="container back-img h-100">
                <div className="row h-100 t bodys">
                  <div className="col-lg-6 my-auto">
                    <div className="header-content mx-auto " data-aos="fade-down" data-aos-duration="2000" >
                      <div className="row title my-4">
                        <div className="col-4">
                          <img src={require('../../static/img/mangaa_logo.png')} className="utasnuud" alt=""></img>
                        </div>
                        <a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
                        <div className="col-7" onClick={() => this.setState(prevState => ({ ergelt_is: !prevState.ergelt_is }))}>
                          <div className="row"><h1 className='my-1'>МАНГАА</h1></div>
                          <div className="row"><h5 className='my-1'> ШИЙТГЭЛИЙН САН</h5></div>
                        </div>
                      </div>
                      <div className="abouts">
                        <h2 className='text-center' data-aos="fade-down" data-aos-duration="2000" >НАЙЗУУД ГЭР БҮЛТЭЙГЭЭ</h2>
                        <h2 className='text-center my-1' data-aos="fade-down" data-aos-duration="2000" >ЦАГИЙГ ЗУГААТАЙ</h2>
                        <h2 className='text-center my-1' data-aos="fade-down" data-aos-duration="2000" >ӨНГӨРҮҮЛЭХ ЦОО ШИНЭ</h2>
                        <h2 className='text-center my-1' data-aos="fade-down" data-aos-duration="2000" >БОЛОМЖ</h2>
                        <br></br>
                      </div>
                      <div className="badge-link android_store text-center container my-4">
                          <div className="row">
                            <a href="https://play.google.com/store/apps/details?id=com.mangaa" className="col" data-aos="fade-up" data-aos-duration="2000">
                              <img className="download-android" data-aos="fade-up" data-aos-duration="2000" src="/static/media/google-play-badge.cfea2442.svg" alt=""></img>
                            </a>
                            <a  href="https://apps.apple.com/mn/app/mangaa-fun/id1527841158?fbclid=IwAR0_KnS1UdgL5pot9NPW8SrkdwRcb2kqmgYMItboEgTrL1KWsf3CAiKmdlQ" className="col" data-aos="fade-up" data-aos-duration="2000">
                              <img className="download-ios" data-aos="fade-up" data-aos-duration="2000" src={require('../../static/img/app-store-badge.svg')} alt=""></img>
                            </a>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="masthead negtal right">
              <img src={require('../../static/img/mangaa_isometric.png')} className="utasnuud" alt=""></img>
              <div className="container back-img h-100">
                <div className="row h-100 t bodys">
                  <div className="col-lg-6 my-auto">
                    <div className="header-content mx-auto " data-aos="fade-down" data-aos-duration="2000" >
                      <div className="row title my-4">
                        <div className="col-4">
                          <img src={require('../../static/img/mangaa_logo.png')} className="utasnuud" alt=""></img>
                        </div>
                        <a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a>
                        <div className="col-7" onClick={() => this.setState(prevState => ({ ergelt_is: !prevState.ergelt_is }))}>
                          <div className="row"><h1 className='my-1'>asdasdasd</h1></div>
                          <div className="row"><h5 className='my-1'> ШИЙТГЭЛИЙН САН</h5></div>
                        </div>
                      </div>
                      <div className="abouts">
                        <h2 className='text-center' data-aos="fade-down" data-aos-duration="2000" >НАЙЗУУД ГЭР БҮЛТЭЙГЭЭ</h2>
                        <h2 className='text-center my-1' data-aos="fade-down" data-aos-duration="2000" >ЦАГИЙГ ЗУГААТАЙ</h2>
                        <h2 className='text-center my-1' data-aos="fade-down" data-aos-duration="2000" >ӨНГӨРҮҮЛЭХ ЦОО ШИНЭ</h2>
                        <h2 className='text-center my-1' data-aos="fade-down" data-aos-duration="2000" >БОЛОМЖ</h2>
                        <br></br>
                      </div>
                      <div className="badge-link android_store text-center container my-4">
                          <div className="row">
                            <a href="https://play.google.com/store/apps/details?id=com.mangaa" className="col" data-aos="fade-up" data-aos-duration="2000">
                              <img className="download-android" data-aos="fade-up" data-aos-duration="2000" src="/static/media/google-play-badge.cfea2442.svg" alt=""></img>
                            </a>
                            <a  href="https://apps.apple.com/mn/app/mangaa-fun/id1527841158?fbclid=IwAR0_KnS1UdgL5pot9NPW8SrkdwRcb2kqmgYMItboEgTrL1KWsf3CAiKmdlQ" className="col" data-aos="fade-up" data-aos-duration="2000">
                              <img className="download-ios" data-aos="fade-up" data-aos-duration="2000" src={require('../../static/img/app-store-badge.svg')} alt=""></img>
                            </a>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Header;
